
document.addEventListener('DOMContentLoaded', function () {
    const labels = document.querySelectorAll('variant-selects div label');
    labels.forEach(label => {
        label.addEventListener('click', function (e) {
            setTimeout(() => {
                const productForm = document.querySelector(`[bss-b2b-product-form="main"]`);
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
            }, 500);
        })
    });
  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
        setTimeout(() => {
            document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
        }, 1000)
    }

    const label = e.target.closest('#wbquickview variant-selects div label');
    if (label) {
      const quickViewCard = label.closest('[bss-b2b-quickview-product-form]');
      if (!quickViewCard) return;

      const productFormId = quickViewCard.getAttribute('bss-b2b-product-form-id');
      if (!productFormId) return;

      const productForm = document.querySelector(
        `[bss-b2b-quickview-product-form][bss-b2b-product-form-id="${productFormId}"]`
      );

      if (productForm) {
        console.log('Variant changed -> triggering observer for', productFormId);

        setTimeout(() => {
            BSS_B2B.observer.productSubject.notifyObserver(
                'VariantChange',
                'VariantSelectChange',
                { productForm }
            );
        }, 1000);
      }
    }
  });
});
